import warehouse from '../../../images/warehouse_service.png';
import './Banner.scss';

export default function Banner() {
	return (
		<section className='main-banner hg-100 d-flex align-items-center' id='main-banner'>
			<div className='container text-white'>
				<div className='row d-flex align-items-center'>
					<div className='col-12 col-md-6 col-lg-6'>
						<h1 className='display-2 fw-200'>
							Soluciones de logística <span className='fw-700'>inteligente</span>
						</h1>
						<p className='py-3 fs-5'>
							Logística de punta a punta, gestionando las entregas a clientes finales,
							recolecciones con sellers o las devoluciones de productos.
						</p>
						<a type='button' href='/#services' className='btn btn-lg btn-banner w-40'>
							Saber Más
						</a>
					</div>
					<div className='col-12 col-md-6 col-lg-6 text-center'>
						<img src={warehouse} alt='Inicio' className='img-fluid img-service' />
					</div>
				</div>
			</div>
		</section>
	);
}
